import { connect } from 'react-redux';
import { getAnswers, getKBSearchResults } from 'app/modules';

import Search from 'presentation/components/__demo__/Search.jsx';
import { updateKBSearchResults, clearKBSearchResults, updateSelectedAnswer } from 'app/modules/knowledge_base/demo';

// Fuse will search based on title and return an array of IDs
function searchKnowledgeBase(fuse, searchTerm) {
  return !!searchTerm ? fuse.search(searchTerm) : [];
}

export const mapStateToProps = state => {
  return {
    answersKB: getAnswers(state),
    prompt: 'Search',
    searchResults: getKBSearchResults(state),
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    onClear: () => {
      dispatch(clearKBSearchResults());
    },
    onSearch: ({ fuse, searchTerm }) => {
      if (searchTerm === '') {
        dispatch(clearKBSearchResults());
      } else {
        let searchResults = searchKnowledgeBase(fuse, searchTerm);
        dispatch(
          updateKBSearchResults({
            searchResultAnswerIds: searchResults,
          })
        );
      }
    },
    onSelectAnswer: answerKey => {
      dispatch(
        updateSelectedAnswer({
          selectedResultAnswerId: answerKey,
        })
      );
      dispatch(clearKBSearchResults());
    },
  };
};

const SearchContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Search);

export default SearchContainer;
